import {
  GET_ROUTE
} from '../../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../../utils/status';

const INIT_STATE = {
  data: undefined,
  uTime: Date.now() // 每次更新的时间戳，用于比较是否变化
};

  
  
export function selectRoute(state, key) {
  let route = state.route.route;

  if (!key) {
    return route;
  } else {
    return route[key];
  }
}
  
export default function reducer(state = INIT_STATE, action) {
  let nextState;
  
  if (action.type === GET_ROUTE) {
    switch (action.status) {
      case PENDING:
        nextState = {
          ...state,
          status: action.status
        };
        break;
      case FAILURE:
      case SUCCESS:
        nextState = {
          ...state,
          uTime: Date.now(),
          data: action.data,
          status: action.status
        };
        break;
      default:
        nextState = state;
    }
  } else {
    nextState = state;
  }
  
  return nextState;
}
  


// WEBPACK FOOTER //
// ./src/store/reducers/route/route.js